// 打包所有租户配置，运行时根据域名选择
const defaultConfig = require('./default/index.js');
const azConfig = require('./az/index.js');

// 运行时根据域名选择配置
function getTenantConfig() {
  const { host } = window.location;

  // 线上环境：根据域名判断
  if (host.includes('astrazeneca')) {
    return azConfig;
  }

  // 本地开发环境：根据构建时环境变量判断
  if (
    host.includes('localhost')
    || host.includes('127.0.0.1')
    || host.includes('saas.local.qq.com')
    || /\.nges\.local(:\d+)?$/.test(host)
  ) {
    const tenant = process.env.VUE_APP_BUILD_TENANT;
    if (tenant === 'az') {
      return azConfig;
    }
  }
  
  return defaultConfig;
}

const envConfig = getTenantConfig();

function setConfig(config) {
  const completeConfig = {
    ...config,
    ...envConfig,
  };
  return completeConfig;
}
// commonConfig保存了与环境无关的固定配置
// 与环境相关的配置需要读store/config获取
const commonConfig = {
  apiProduct: 2,
  apiPlatform: 2, // siwen todo；1和3 是 WEB和H5?
  
  cosAppId: 'nges',
  product: 'saas',
  company: 'tencent',
  api: '/api/access/json',
  cloud: '/api/access/pb',
  apiList: [], // 非云上接口列表
  whiteFilter: [
    'AccountServer/AccountLogin/Login',
    'AccountServer/AccountLogin/LoginWithWorkWeixinByThirthQr',
    'NgesServer/NgesApp/GetWebLoginConfig',
    'AccountServer/AccountBase/ParseToken',
    'NgesServer/NgesApp/GetAppConfig',
  ],
  layoutFilter: ['help', 'login', 'protocol', 'door', 'ticket'],
  rightFilter: [
    'help',
    'login',
    'protocol',
    'register',
    'door',
    'ticket',
    'custom',
    'rame',
    'wujie',
    'layoutList',
    'layoutDetail',
    'layoutTab',
    'layoutMutation',
    'noPermission',
    'iframe',
  ],
};
const config = setConfig(commonConfig);
console.log('config', config);
export default config;
